import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { InfoTooltipLink, StandardSelect } from 'components'
import { properCase } from 'utils/properCase'
import { citizenshipFilterGroups } from 'services/options-lists'

const CitizenshipStatus = ({
  translate,
  filters,
  criteria,
  multiples,
  defaultValue,
  onFilter,
  setMultiples,
  setFilters,
  citizenshipSchema,
}) => {
  const [citizenshipGrouped, setCitizenshipGrouped] = useState([])
  const groupValues = []

  if (
    defaultValue?.citizenshipRequirementsList === undefined ||
    defaultValue?.citizenshipRequirementsList === null
  ) {
    defaultValue.citizenshipRequirementsList = []
  }

  const options = useMemo(
    () => [
      {
        options: citizenshipFilterGroups,
      },
      {
        options: citizenshipSchema
          .map((item) => item.elementValue)
          .map((item) => ({
            value: item,
            label: properCase(item),
          })),
        header: <hr className="border-secondary my-1" />,
      },
    ],
    [criteria]
  )

  const getCitizenshipGroups = useCallback(() => {
    for (const group of citizenshipFilterGroups) {
      const values = citizenshipSchema.filter(
        (item) => item?.groups && item?.groups[0] === group.value
      )
      const valuesSanitized = values.map((item) => item.elementValue)
      groupValues.push({ group, values: valuesSanitized })
    }

    setCitizenshipGrouped(groupValues)
  }, [])

  useEffect(() => {
    getCitizenshipGroups()
  }, [getCitizenshipGroups])

  const handleCitizenshipFilter = useCallback(
    (values) => {
      const filterList = []

      values && values.forEach((item) => {
        const citizens = item.value === citizenshipGrouped.find(({group, values}) => 
            (group.value ===  item.value) && filterList.push(...values)
        )
        if (
          !citizenshipFilterGroups
            .filter((item) => item !== 'Any Citizenship Requirement')
            .includes(item.value)
        ) {
          filterList.push(item.value)
        }
      })

      setMultiples({
        ...multiples,
        citizenshipRequirementsList: values,
        citizenshipRequirements: filterList,
      })
      onFilter({
        citizenshipRequirementsList: values,
        citizenshipRequirements: filterList,
      })

      if (filterList.length === 0) {
        defaultValue.citizenshipRequirementsList = null
        defaultValue.citizenshipRequirements = null
        setFilters(
          filters.filter(
            (f) =>
              f !== 'citizenshipRequirementsList' &&
              f !== 'citizenshipRequirements'
          )
        )
      } else {
        if (
          !filters.includes(
            'citizenshipRequirementsList',
            'citizenshipRequirements'
          )
        ) {
          setFilters(
            filters.concat(
              'citizenshipRequirementsList',
              'citizenshipRequirements'
            )
          )
        }
      }
    },
    [
      citizenshipGrouped,
      defaultValue,
      filters,
      multiples,
      onFilter,
      setFilters,
      setMultiples,
    ]
  )

  const formatGroupLabel = useCallback(({ header }) => header || null, [])
  const styles = useMemo(
    () => ({ group: () => ({ paddingBottom: 0, paddingTop: 0 }) }),
    []
  )

  return (
    <Row>
      <Col>
        <div className="d-flex">
          {translate('citizenship')}
          <InfoTooltipLink
            link={translate('programSearchCitizenshipLink')} 
            text={translate('tooltipProgramSearchCitinzenshipStatus')} 
            className="ml-2" 
          />
        </div>
        <StandardSelect
          isMulti
          placeholder=""
          isClearable
          onChange={(e) => handleCitizenshipFilter(e)}
          value={defaultValue?.citizenshipRequirementsList}
          {...{
            formatGroupLabel,
            styles,
            options,
          }}
        />
      </Col>
    </Row>
  )
}

export default CitizenshipStatus
